export default __webpack_public_path__ + "static/media/slide1.7e7ab7e1.jpg";